<template>
  <div
    class="preview-event-banner"
    :style="bannerStyle"
  >
    <img
      v-if="bannerUrl"
      :src="bannerUrl"
      alt="Banner"
      class="banner-image"
    >
    <div
      v-else
      class="banner-placeholder"
    >
      <v-icon
        small
        color="white"
      >
        mdi-image
      </v-icon>
      <span>バナー画像</span>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  name: 'PreviewEventBanner',

  props: {
    bannerUrl: {
      type: String,
      default: null,
    },
    theme: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const bannerStyle = computed(() => {
      if (!props.bannerUrl) {
        return {
          background: `linear-gradient(135deg, ${props.theme.cardColor}, ${props.theme.primaryColor}30)`,
        }
      }

      return {}
    })

    return {
      bannerStyle,
    }
  },
}
</script>

<style scoped>
.preview-event-banner {
  width: 100%;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 8px;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.5);
  gap: 4px;
}

.banner-placeholder span {
  font-size: 10px;
}
</style>
